import { useContext, useState } from 'react';
import { LayoutContext } from '../context';
import { APIEnsureEventChat } from '../api';

/**
 * openEventChat(event, opts?)
 *  - event: объект события (нужен .id; .event_chat опционально — для имени)
 *  - opts.open(chatId, chatName): кастомное открытие (например inline-панель
 *    менеджера через setChatPanel). По умолчанию — setChatModal.
 */
export function useOpenEventChat() {
  const { tokenEmployee, setChatModal, notify } = useContext(LayoutContext);
  const [ensuring, setEnsuring] = useState(false);

  const openEventChat = async (event, opts = {}) => {
    const eventId = event?.id;
    if (!eventId) { notify?.('Событие не найдено', 'danger'); return; }
    const chatName = event?.event_chat?.name || `Событие #${event?.bitrix_deal?.id || eventId}`;

    setEnsuring(true);
    try {
      const r = await APIEnsureEventChat(eventId, tokenEmployee);
      if (!r?.chat_id) { notify?.(r?.error || 'Не удалось открыть чат команды', 'danger'); return; }
      if (opts.open) opts.open(r.chat_id, chatName);
      else setChatModal({ open: true, chatId: r.chat_id, chatName });
    } catch {
      notify?.('Не удалось открыть чат команды', 'danger');
    } finally { setEnsuring(false); }

  };

  return { openEventChat, ensuring };
}